import { deleteTags, updateTags } from "@/services";
import { Dropdown, Form, Input } from "antd";
import Link from "next/link";
import { useCallback, useMemo, useRef } from "react";
import { When } from "react-if";
import HBIcon from "../HBIcon";
import HBMessage from "../HBMessage";
import HBModal from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import HBConfirm from "../HBModal/confirm";
import styles from "./index.module.less";

// 标签重命名弹窗
const TagRenameModal = ModalWrap(({ onOk, record, ...props }) => {
  const formRef = useRef(null);

  const onSubmit = useCallback(async () => {
    const value = await formRef.current.validateFields();
    if (!value?.name) {
      HBMessage.error("标签名称必填");
      return;
    }
    const result = await updateTags({
      old_tags: [record?.tag_name],
      new_tags: [value.name],
    });
    if (!result?.err) {
      HBMessage.success(result?.msg || "重命名已完成，采集内的标签正在更新");
      onOk && onOk(record);
    }
  }, [onOk, record]);

  return (
    <HBModal
      width={480}
      title="重命名标签"
      okText="保存"
      cancelText="取消"
      onOk={onSubmit}
      {...props}
    >
      <Form
        ref={formRef}
        className={styles.form}
        initialValues={{ name: record?.tag_name }}
      >
        <Form.Item
          name="name"
          help="重命名后，采集内的标签需要一点时间才能更新，请稍等片刻再查看"
        >
          <Input className={styles.input} placeholder="标签名称" allowClear />
        </Form.Item>
      </Form>
    </HBModal>
  );
});

// 用户标签组件
export default function UserTag({
  record,
  urlname,
  isMe,
  onDelete: _onDelete,
  onRename: _onRename,
  link = null, // 标签链接
}) {
  const onRename = useCallback(() => {
    TagRenameModal.open({
      record,
      onOk: () => {
        _onRename && _onRename(record);
      },
    });
  }, [_onRename, record]);

  const onDelete = useCallback(async () => {
    HBConfirm.open({
      title: "删除提示",
      content: (
        <>
          <div>删除标签后不能恢复，确定要删除吗？</div>
          <div>
            该标签将从 {record?.count} 个采集下删除，采集本身不会被删除。
          </div>
        </>
      ),
      onOk: async () => {
        const result = await deleteTags({ tags: [record.tag_name] });
        if (!result?.err) {
          HBMessage.success("成功删除标签");
          _onDelete && _onDelete(record);
        }
      },
    });
  }, [_onDelete, record]);

  const menu = useMemo(() => {
    return (
      <div className={styles.menu}>
        <a className={styles.menuItem} onClick={onRename}>
          <span className={styles.text}>重命名</span>
        </a>
        <a className={styles.menuItem} onClick={onDelete}>
          <span className={styles.text}>删除标签</span>
        </a>
      </div>
    );
  }, [onDelete, onRename]);

  // 标签链接
  const tagLink = useMemo(() => {
    if (link) {
      return link;
    }
    return `/user/${urlname}/tags/${encodeURIComponent(record?.tag_name)}/pins`;
  }, [link, record?.tag_name, urlname]);

  return (
    <div className={styles.tag}>
      <Link href={tagLink} passHref>
        <a className={styles.container}>
          <div className={styles.name}>{record?.tag_name}</div>
          <div className={styles.num}>{record?.count}</div>
        </a>
      </Link>
      <When condition={isMe}>
        <Dropdown overlay={menu} placement="bottomRight">
          <div className={styles.more}>
            <HBIcon
              className={styles.icon}
              type="ic_more"
              onClick={(evt) => evt.stopPropagation()}
            />
          </div>
        </Dropdown>
      </When>
    </div>
  );
}
